import classNames from 'classnames'
import React, { useEffect, useState } from 'react'

import { DropdownProps } from './dropdown.types.ts'

const Dropdown = <T,>({
  options,
  labelExtractor,
  onSelect,
  placeholder = 'Wybierz z listy',
  optionOnStart = undefined,
  makeReset = undefined,
  className = '',
  selectClassName = ''
}: DropdownProps<T>) => {
  const [selectedValue, setSelectedValue] = useState<T | null>(null)

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedIndex = event.target.selectedIndex - 1
    const selected = selectedIndex >= 0 ? options[selectedIndex] : null
    setSelectedValue(selected)
    onSelect(selected)
  }

  useEffect(() => {
    if (optionOnStart !== undefined) setSelectedValue(options[optionOnStart])
  }, [optionOnStart])

  useEffect(() => {
    if (makeReset) setSelectedValue(null)
  }, [makeReset, options])

  return (
    <div className={classNames('flex flex-col items-center p-4', className)}>
      <select
        onClick={(e) => e.stopPropagation()}
        value={selectedValue ? labelExtractor(selectedValue) : ''}
        onChange={handleChange}
        className={classNames(
          'w-[100%] border border-gray-300 dark:border-gray-600 rounded p-2 bg-white dark:bg-gray-800 text-black dark:text-white',
          selectClassName
        )}
      >
        <option value="" disabled>
          {placeholder}
        </option>
        {options.map((option, index) => (
          <option
            key={index}
            value={labelExtractor(option)}
            className="bg-white dark:bg-gray-800 text-black dark:text-white"
          >
            {labelExtractor(option)}
          </option>
        ))}
      </select>
    </div>
  )
}

export default Dropdown
